/* ==========================================================================
   Comportements des blocs custom du product info.
   Charge en defer depuis sections/main-product.liquid.

   Principe general : tout est rendu cote serveur. Le JS ne fait que corriger
   ou enrichir un contenu deja present, jamais le fabriquer. Consequence : si
   ce fichier ne se charge pas, la page reste complete et aucun element ne
   bouge apres coup.
   ========================================================================== */
(function () {
  'use strict';

  var REVIEWS_SELECTOR = '.jdgm-rev-widg, #judgeme_product_reviews';

  function scrollToReviews() {
    var target = document.querySelector(REVIEWS_SELECTOR);
    if (!target) return false;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  /* ---------- Description : Lire plus / Lire moins ---------- */
  function initDescriptionToggles(scope) {
    scope.querySelectorAll('.product__description-toggle').forEach(function (toggle) {
      if (toggle.dataset.toggleInitialized) return;

      var content = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!content) return;

      toggle.dataset.toggleInitialized = 'true';

      // Si le texte n'est pas reellement tronque, le bouton n'a pas lieu d'etre.
      if (content.scrollHeight <= content.clientHeight + 2) {
        toggle.hidden = true;
        return;
      }

      toggle.hidden = false;

      toggle.addEventListener('click', function () {
        var collapsed = content.getAttribute('data-collapsed') === 'true';
        content.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');

        var span = toggle.querySelector('span');
        if (span) {
          span.textContent = collapsed ? span.dataset.lessText : span.dataset.moreText;
        }
      });
    });
  }

  /* ---------- Date de livraison : correction du cache ---------- */
  /* La fourchette est calculee en Liquid, donc presente des le premier rendu.
     Mais Shopify met les pages produit en cache : une date figee dans du HTML
     cache devient fausse des le lendemain. On recalcule ici et on ne touche au
     DOM que si le resultat differe, ce qui evite tout repaint inutile. */
  function initDeliveryDates(scope) {
    var nodes = scope.querySelectorAll('[data-delivery-range]');
    if (!nodes.length) return;

    var locale = document.documentElement.lang || 'fr';
    var dayFmt, monthFmt;

    try {
      dayFmt = new Intl.DateTimeFormat(locale, { day: 'numeric' });
      monthFmt = new Intl.DateTimeFormat(locale, { month: 'long' });
    } catch (e) {
      return; // Locale invalide : on garde le rendu serveur.
    }

    nodes.forEach(function (el) {
      if (el.dataset.deliveryInitialized) return;
      el.dataset.deliveryInitialized = 'true';

      var min = parseInt(el.dataset.deliveryMin, 10);
      var max = parseInt(el.dataset.deliveryMax, 10);
      var template = el.dataset.deliveryTemplate;

      if (isNaN(min) || isNaN(max) || !template) return;

      var now = new Date();
      var start = new Date(now.getTime());
      start.setDate(start.getDate() + min);
      var end = new Date(now.getTime());
      end.setDate(end.getDate() + max);

      var startDay = dayFmt.format(start);
      var endDay = dayFmt.format(end);
      var startMonth = monthFmt.format(start);
      var endMonth = monthFmt.format(end);

      var range =
        startMonth === endMonth
          ? startDay + '-' + endDay + ' ' + startMonth
          : startDay + ' ' + startMonth + ' - ' + endDay + ' ' + endMonth;

      var next = template.replace('{dates}', range);

      if (el.textContent.trim() !== next) {
        el.textContent = next;
      }
    });
  }

  /* ---------- Resume de la note : defilement vers les avis ---------- */
  /* Le lien est un vrai <a href="#judgeme_product_reviews"> : sans JS il
     fonctionne deja si l'ancre existe. Ce handler ne fait qu'ajouter le
     defilement doux et rattraper le cas ou Judge.me expose .jdgm-rev-widg
     sans l'id attendu. */
  function initRatingSummary(scope) {
    scope.querySelectorAll('[data-scroll-to-reviews]').forEach(function (link) {
      if (link.dataset.scrollInitialized) return;
      link.dataset.scrollInitialized = 'true';

      link.addEventListener('click', function (event) {
        if (scrollToReviews()) event.preventDefault();
      });
    });
  }

  /* ---------- Avis vedette : navigation entre slides ---------- */
  /* Les slides sont rendues cote serveur par snippets/product-featured-reviews.
     Le JS ne fait que basculer la visibilite : si le JS echoue, le premier
     avis reste affiche et rien ne bouge. */
  function initFeaturedReviews(scope) {
    scope.querySelectorAll('.product__featured-reviews-card').forEach(function (card) {
      if (card.dataset.reviewsInitialized) return;
      card.dataset.reviewsInitialized = 'true';

      var slides = Array.prototype.slice.call(
        card.querySelectorAll('.product__featured-reviews-slide')
      );
      var prevBtn = card.querySelector('.product__featured-reviews-chevron--prev');
      var nextBtn = card.querySelector('.product__featured-reviews-chevron--next');

      card.querySelectorAll('.product__featured-reviews-seemore').forEach(function (btn) {
        btn.addEventListener('click', scrollToReviews);
      });

      if (slides.length <= 1) {
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
        return;
      }

      var current = 0;

      function show(index) {
        slides.forEach(function (slide, i) {
          slide.hidden = i !== index;
        });
        card.setAttribute('aria-label', 'Avis ' + (index + 1) + ' sur ' + slides.length);
      }

      if (prevBtn) {
        prevBtn.hidden = false;
        prevBtn.addEventListener('click', function () {
          current = (current - 1 + slides.length) % slides.length;
          show(current);
        });
      }

      if (nextBtn) {
        nextBtn.hidden = false;
        nextBtn.addEventListener('click', function () {
          current = (current + 1) % slides.length;
          show(current);
        });
      }

      show(0);
    });
  }

  /* ---------- Effet holographique au defilement ---------- */
  var holoBound = false;

  function updateHoloBackgrounds() {
    var w = window.innerWidth + 'px ';
    var h = window.innerHeight + 'px';

    document.querySelectorAll('[data-has-holo] .product__holo').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      el.style.backgroundSize = w + h;
      el.style.backgroundPosition = -rect.left + 'px ' + -rect.top + 'px';
    });
  }

  function initHoloBackgrounds() {
    if (!document.querySelector('[data-has-holo]')) return;

    // Respecte la preference systeme : pas de recalcul au scroll.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      updateHoloBackgrounds();
      return;
    }

    updateHoloBackgrounds();

    if (holoBound) return;
    holoBound = true;

    var ticking = false;

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateHoloBackgrounds();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
  }

  /* ---------- Orchestration ---------- */
  function runAll(root) {
    var scope = root && root.querySelectorAll ? root : document;

    initDescriptionToggles(scope);
    initDeliveryDates(scope);
    initRatingSummary(scope);
    initFeaturedReviews(scope);
    initHoloBackgrounds();
  }

  function boot() {
    runAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Editeur de theme et rechargement partiel du bloc produit.
  ['shopify:section:load', 'product-info:loaded'].forEach(function (evt) {
    document.addEventListener(evt, function (event) {
      runAll(event.target || document);
    });
  });
})();
